module.exports = __webpack_public_path__ + "img/goodTooth.24427e43.png";